// Configuración pública del frontend.
// El número de WhatsApp vive como variable de entorno en Netlify
// (WHATSAPP_NUMBER) y lo maneja /.netlify/functions/enviar-pedido.
export const CONFIG = {
  businessName: 'IDG',
  logoText: 'IDG',
  logoImage: '/idg-logo.jpeg',
  // Site key pública de Cloudflare Turnstile. Dejar '' para desactivar.
  turnstileSiteKey: ''
};
